import styled from "styled-components";
import bannerBg from "../../../../assets/images/bg/banner_bg_3.jpg";

const BannerStyleWrapper = styled.section`
  background: url(${bannerBg});
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  padding: 192px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .popUp_container {
    position: absolute;
    width: 100%;
    height: 100%;
    align-items: center;
    align-self: center;

    padding-top: 25rem;
    backdrop-filter: blur(10px);

    z-index: 1000000;
  }

  .mint_count_list {
    padding: 0;
    margin: 2rem auto;
    width: 300px;

    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 56px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      border-top: 1px solid rgba(255, 255, 255, 0.1);

      h5 {
        font-family: "Inter";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        text-align: right;
        color: #ffffff;
        margin-bottom: 0;
      }
    }
  }

  .mint_quantity_sect {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 94px;
    width: 100%;
    height: 100%;

    .input_number_decrement{
      padding: 0 10px;
    }

    
    .input_number_increment{
      padding: 0 10px;
    }

    .input_number {
      min-width: 60px;
    }

    button {
      border: none;
      outline: none;
      background: transparent;
      padding: 0px;
      font-family: "Bakbak One";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      text-transform: uppercase;
      color: #ffffff;
    }

    input {
      max-width: 58px;
      width: 100%;
      border: none;
      border-left: 1px solid rgba(255, 255, 255, 0.1);
      border-right: 1px solid rgba(255, 255, 255, 0.1);
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      padding: 0px 19px;
      outline: none;
      font-family: "Bakbak One";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      text-transform: uppercase;
      color: #ffffff;
    }
  }

  .bithu_v2_baner_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    .banner-emot {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
    }
    h2 {
      font-family: "Bakbak One";
      font-style: normal;
      font-weight: 400;
      font-size: 60px;
      line-height: 60px;
      text-align: center;
      text-transform: uppercase;
      color: #ffffff;
      margin-bottom: 29px;
      position: relative;
      z-index: 2;
      span {
        color: #59bd8d;
      }
    }
    h3 {
      font-size: 40px;
      line-height: 65px;
      text-align: center;
      text-transform: uppercase;
      color: #ffffff;
      position: relative;
      margin: 0;
      z-index: 2;
    }

    span {
      display: inline-block;
    }

    .bithu_v2_timer {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 15px;
      z-index: 2;
      h4 {
        font-size: 40px;
        line-height: 65px;
        text-align: center;
        text-transform: uppercase;
        color: #ffffff;
        margin: 0;
      }
    }

    .bithu_v2_baner_buttons {
      padding: 1rem 0;
      button {
        margin: 0 auto;
      }
    }

    .v2_baner_stars {
      top: -80px;
      height: 499px;
    }
  }

  .footer_banner {
    p {
      text-align: center;
      font-size: 10px;
      margin-top: 23px;
      a {
        font-size: 10px;
        color: rgba(255, 255, 255, 0.8);
        font-weight: 600;
        text-decoration: underline !important;
      }
    }
  }

  /* timer  */
  .countdown_wrapper {
    line-height: 65px;
    text-align: center;
    text-transform: uppercase;
    color: #ffffff;
    column-gap: 15px;
    .count_number {
      font-family: "Bakbak One";
      font-size: 40px;
      column-gap: 10px;
      padding-right: 30px;

      .label {
        display: none;
      }
    }
  }

  @media only screen and (max-width: 991px) {
    padding-bottom: 80px;

    .bithu_v2_baner_content {
      h2 {
        font-size: 50px;
      }

      h3 {
        font-size: 35px;
      }

      .bithu_v2_timer {
        h4 {
          font-size: 35px;
        }
      }
    }
  }

  @media only screen and (max-width: 575px) {
    .bithu_v2_baner_content {
      h2 {
        font-size: 30px;
        margin-bottom: 20px;
      }
      h3 {
        font-size: 21px;
      }

      .bithu_v2_timer {
        h4 {
          font-size: 21px;
        }
      }
    }

    .countdown_wrapper {
      column-gap: 10px;
      .count_number {
        padding-right: 15px;
        font-size: 21px;
      }
    }
  }
`;

export default BannerStyleWrapper;
